const typography = {
  '--font-primary': '"Instrument Sans", sans-serif',
}

export default typography
